export default __webpack_public_path__ + "static/body-v2-08-hips-342e1f88136de82612eb318508826195.png";